import styled from '@emotion/styled';

const Tab = styled('button', {
  label: 'Tab',
})<{ selected: boolean }>`
  font-size: 0.9rem;
  font-weight: 500;
  color: ${({ selected }) => (selected ? '#1f2d49' : '#8B8B8B')};
  border: none;
  background-color: transparent;
  padding: 0;
  display: flex;
  justify-content: center;
`;

export default Tab;
